import React from 'react';
import { useTranslation } from 'react-i18next';

interface PaymentModalProps {
    type: 'success' | 'failure';
    paymentType?: 'donation' | 'ticket';
    onClose: () => void;
}

export default function PaymentModal({ type, paymentType = 'donation', onClose }: PaymentModalProps) {
    const { t } = useTranslation();
    const isSuccess = type === 'success';
    const isTicket = paymentType === 'ticket';

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
            <div className="bg-white rounded-xl shadow-xl max-w-sm w-full p-6 text-center animate-fade-in">
                <div className="flex justify-center mb-4">
                    {isSuccess ? (
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-16 w-16 text-green-500"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth={2}
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                        </svg>
                    ) : (
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-16 w-16 text-red-500"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth={2}
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    )}
                </div>

                <h2 className="text-2xl font-bold mb-2">
                    {isSuccess ? (
                        isTicket ? t('payment.ticket_success_title', 'Билет успешно оформлен!') : t('payment.success_title')
                    ) : (
                        t('payment.failure_title')
                    )}
                </h2>

                <p className="text-gray-600 mb-6">
                    {isSuccess ? (
                        isTicket ? (
                            <>
                                {t('payment.ticket_success_text', 'Ваш билет был успешно оформлен и отправлен на указанный email.')}
                                <br /><br />
                                {t('payment.ticket_email_info', 'В письме вы найдете ссылку для скачивания PDF-билета, который нужно будет предъявить при входе на фестиваль.')}
                            </>
                        ) : (
                            t('payment.success_text')
                        )
                    ) : (
                        t('payment.failure_text')
                    )}
                </p>

                <button onClick={onClose} className="btn-primary w-full">
                    {t('payment.close')}
                </button>
            </div>
        </div>
    );
}